/*
 * -----------------------------------------------------------------------
 *  <copyright file="file-service.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

const downloadBase64File = (filename: string, contents: string) => {
    download(filename, contents, 'data:appliation/octet-stream;base64');
};

const downloadUTF8File = (filename: string, contents: string) => {
    download(filename, contents, 'data:test/csv;charset=utf-8');
};

const download = (filename: string, contents: string, dataType: string) => {
    fetch(`${dataType},${contents}`)
        .then((res) => res.blob())
        .then((blob: any) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
        });
};

export {
    // eslint-disable-next-line import/prefer-default-export
    downloadBase64File,
    downloadUTF8File,
};
